module.exports = __webpack_public_path__ + "img/d2tLogo.61bf3f6a.svg";